import createAction from '../utils/createAction'
import * as ActionTypes from '../constants/ActionTypes'

export const setSelectedScreening = id =>
  createAction(ActionTypes.SET_SELECTED_SCREENING, {
    id,
  })
